import * as React from 'react';

interface BusyDialogProps {
  visible: boolean;
  caption: string;
}

const BusyDialog: React.SFC<BusyDialogProps> = (props) => {
  const dialogStyle: React.CSSProperties = {
    visibility: props.visible ? 'visible' : 'hidden',
  };

  return (
    <div className="mdc-dialog mdc-dialog--open" style={dialogStyle}>
      <div className="mdc-dialog__surface">
        <section className="mdc-dialog__body">
          {props.caption}
        </section>
      </div>
      <div className="mdc-dialog__backdrop"></div>
    </div>
  );
};

export default BusyDialog;
